/* eslint-disable import/prefer-default-export */
import styled from 'styled-components';

export const BookmarkContainer = styled.div`
  position: relative;
  height: 100%;
  .bookmark-icon {
    display: none;
    top: ${(props) => props.top || '4'}px;
    right: ${(props) => props.right || '6'}px;
    position: absolute;
    z-index: 9;
    cursor: pointer;
    align-items: center;
    justify-content: center;

    & > svg path {
      position: relative;
      fill: ${(props) => props.color || 'black'};
    }
  }

  .bookmark-label {
    font-family: var(--font-family-body);
    margin-left: 8px;
    color: ${(props) => props.color || 'black'};

    @media (max-width: 575px) {
      display: none;
    }
  }

  ${(props) =>
    (props.hasCtaLink || props.url) &&
    `
      :hover {
        .section-podcast-hero--image-container,
        .card--cover {
          background-color: black;

          .section-podcast-hero--image,
          .tool-card--image,
          .card--cover-image {
            opacity: 0.5;
          }
          .card--cover-mark-icon,
          > svg {
            opacity: 1;
          }
        }
        > a > .gatsby-image-wrapper {
          opacity: 0.5;
          background-color: black;
        }
        .bookmark-icon > svg {
          opacity: 1;
        }
      }
    `}

  &.bookmark-container--podcast-type {
    .bookmark-icon {
      top: 8px;
      right: 17px;

      @media (max-width: 575px) {
        right: 25px;
      }

      @media (max-width: 460px) {
        right: 18px;
      }
    }
  }

  &.bookmark-container--success-stories-type {
    .bookmark-icon {
      right: 52px;

      @media (max-width: 991px) {
        right: 62px;
      }

      @media (max-width: 575px) {
        right: 42px;
      }
    }

    @media (max-width: 575px) {
      .success-story-card--title {
        padding-right: 15px;
      }
    }
  }

  &.bookmark-container--breadcrumb-type {
    .bookmark-icon {
      top: 12px;
    }
  }
`;
